import React, { useState } from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import { HighchartBarChart,
    CustomButtonGroup,
    USACountryChart } from '../../../shared';
import { DISTRIBUTION_CHART_OPTIONS, USA_CHART_OPTIONS, USA_CITY_CHART_OPTIONS, hideDistrictMap, mapOptions } from './constants';
import USACountryCityChart from '../../../shared/usaCountryCityChart';

function CityBreakdown() {
    const BREAKDOWN = ['City', 'State'];
    const [selectedBreakdown, setSelectedBreakdown] = useState(BREAKDOWN[1]);
    const { company } = useSelector((state) => state.company);
    const { dtcData } = useSelector((state) => state.webMatrix);
    const {
        cityOverallPhysicians, 
        stateOverallPhysicians,
        isWebMatrixPatientLoading, 
        cityDistributionRegion, 
        stateDistributionRegion,
        stateMapSeries,
        cityMapSeries
    } = dtcData;

    const handleDistrictBreakdown = (option) => {
        setSelectedBreakdown(option);
    };
    const handleCustomisation = () => {
        let chartSeries = [], breakdown = '';
        if(selectedBreakdown === BREAKDOWN[1]){
            chartSeries = stateDistributionRegion;
            breakdown = 'State';
        } else {
            chartSeries = cityDistributionRegion;
            breakdown = 'City';
        }

        return { chartSeries, breakdown };
    };
    return (
        <Box className="box-sizing-border-box padding-24px">
            <Box className="padding-tb-20 border-bottom-gray flex-row-space-between-center">
                <Box>
                    <Typography className="text-md-medium gray-900">
                        Geographical Engagement Breakdown
                    </Typography>
                </Box>
                {/* {
                    !hideDistrictMap.includes(company.id) 
                        ? (<Box>
                            <CustomButtonGroup
                                data={BREAKDOWN}
                                handleClick={(option) => handleDistrictBreakdown(option)}
                                key="breakdown"
                                selected={selectedBreakdown}
                            />
                        </Box>)
                        : null 
                } */}
            </Box>

            <Grid container className="flex-row-center">
                <Grid item className="us-bubble-map-container" lg={7} xl={8}>
                    {/* Location Chart */}
                    {
                        isWebMatrixPatientLoading
                            ? <Skeleton height={300} variant="rectangular" width='95%'/> : 
                            selectedBreakdown === BREAKDOWN[0] 
                                ? <USACountryCityChart
                                    chartOptions={USA_CITY_CHART_OPTIONS}
                                    mapSeries={cityMapSeries}
                                />
                                : <USACountryChart
                                    chartOptions={USA_CHART_OPTIONS}
                                    mapSeries={stateMapSeries}
                                />
                    }
                </Grid>

                <Grid
                    item
                    lg={5}
                    xl={4}
                >
                    <Box className="container-p-24-br-16 bg-gray-50 mt-24px">
                        {/* Location Info */}
                        <Box className="flex-column gap-4">
                            <Typography className="text-md-medium gray-900">
                                {handleCustomisation().breakdown} Breakdown of Paid Media Engagement
                            </Typography>
                            <Typography className="text-sm-regular gray-500">
                                {
                                    isWebMatrixPatientLoading 
                                        ? <Skeleton variant='text' width={100}/> 
                                        : hideDistrictMap.includes(company.id)  
                                            ? stateOverallPhysicians
                                            : cityOverallPhysicians
                                } Overall Count
                            </Typography>
                        </Box>
                        <Box className="pt-24px district-breakdown-bar-chart">
                            {isWebMatrixPatientLoading ? <Skeleton height={300} variant="rectangular" width='100%' /> :
                                <HighchartBarChart 
                                    chartOptions={{
                                        ...DISTRIBUTION_CHART_OPTIONS,
                                        chart: {
                                            ...DISTRIBUTION_CHART_OPTIONS.chart,
                                            height: (hideDistrictMap.includes(company.id) || BREAKDOWN[1] === selectedBreakdown) 
                                                ? (stateDistributionRegion.length > 0 
                                                    ? stateDistributionRegion.length * 35
                                                    : 0)
                                                : (cityDistributionRegion.length > 0 
                                                    ? cityDistributionRegion.length * 35 
                                                    : 0)
                                        }
                                    }}
                                    key={`chart-${selectedBreakdown}-${company.id}`}
                                    seriesData={handleCustomisation().chartSeries} 
                                    seriesName="Digital Engagement" 
                                />
                            }
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default CityBreakdown;